var helperGetDateTime = require('./helperGetDateTime')
var helperNewDate = require('./helperNewDate')

/**
 * 返回当前时间戳
 *
 * @returns Number
 */
var now = Date.now || function () {
  return helperGetDateTime(helperNewDate())
}

module.exports = now



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/now.js
// module id = 524
// module chunks = 75